// init the nav
require('app/includes/nav');

// since most pages have a case evaluation form, attempt to load it and just catch the error if it fails
try {
    require('includes/case-evaluation-form')
} catch (exc) {
    console.warn(exc);
}

// set the tracked landing page to the current page
import { setTrackedLandingPage } from 'lib/attribution';

// set a 30 day look back window on attribution
setTrackedLandingPage(document.location.href, 30);


// WEBPACK FOOTER //
// ./assets/js/app/core.js